// Shared by mapOrderToReceipt.js (which precomputes these once) and anything
// else that needs to turn a savings_message_template + amount into display
// text — the {amount} substitution itself always happens client-side; the API
// only ever gives back the raw template string (see docs/features/pos-receipt-template
// in apex_v3 for the full contract).
export function substituteAmount(template, amount) {
  return String(template || '').replace('{amount}', parseFloat(amount || 0).toFixed(2));
}
